import axios from 'axios';

const state = {
    data: null,
    isLoading: false,
    error: null,
    constructionData: null
};

export const mutationTypes = {
    getRspStart: '[rsp] Get data start',
    getRspSuccess: '[rsp] Get data success',
    getRspFailure: '[rsp] Get data failure',
    setRspActiveProgram: '[rsp] set active program'
};

export const rspActionTypes = {
    getRsp: '[rsp] Get data'
};

const mutations = {
    [mutationTypes.getRspStart](state) {
        state.isLoading = true;
    },
    [mutationTypes.setRspActiveProgram](state, payload) {
        state.data.activeProgram = '';
        state.data.activeType = '';
        let program = new URLSearchParams(payload);
        for (let [key, value] of program) {
            if (key === 'program') {
                state.data.activeProgram = value;
            }
            if (key === 'type') {
                state.data.activeType = value;
            }
        }
    },
    [mutationTypes.getRspSuccess](state, payload) {
        state.data = payload;
        state.isLoading = false;
    },
    [mutationTypes.getRspFailure](state) {
        state.isLoading = false;
    }
};

const actions = {
    async [rspActionTypes.getRsp](context, { apiUrl, rspFilter }) {
        context.commit(mutationTypes.getRspStart);
        try {
            const response = await axios.get(apiUrl + rspFilter);
            context.commit(mutationTypes.getRspSuccess, response.data);
            context.commit(mutationTypes.setRspActiveProgram, rspFilter);
        } catch (e) {
            context.commit(mutationTypes.getRspFailure);
        }
    }
};

export default {
    state,
    actions,
    mutations
};
